import { POLYGON_API_PATH } from 'utils/constants'
import Api from './axiosInstance'

// To get all Polygon Data
export const getPolygonData = () => {
  return Api.post({ url: POLYGON_API_PATH.POLYGON_SYNC })
}
